/** Device-local, account-scoped positions only. No message content or server read receipt. */
interface Position { messageId: string; expiresAt: string }
type Positions = Record<string, Position>;
const memory = new Map<string, Positions>();
const failedWrites = new Set<string>();
const key = (account: string) => `perhaps.friendship.read.${account}`;
function positions(account: string, now = Date.now()): Positions {
  let result = memory.get(account) ?? {};
  try { if (!failedWrites.has(account)) { const raw = localStorage.getItem(key(account)); result = raw ? JSON.parse(raw) : {}; } } catch { /* In-memory fallback for unavailable storage. */ }
  if (!result || typeof result !== 'object' || Array.isArray(result)) result = {};
  return Object.fromEntries(Object.entries(result).filter(([, item]) => item && typeof item.messageId === 'string' && Date.parse(item.expiresAt) > now));
}
function save(account: string, value: Positions) {
  memory.set(account, value);
  try { if (Object.keys(value).length) localStorage.setItem(key(account), JSON.stringify(value)); else localStorage.removeItem(key(account)); failedWrites.delete(account); } catch { failedWrites.add(account); }
}
export function groupHasUnread(account: string | null, group: { id: string; lastVisibleMessageId: string | null; expiresAt: string }): boolean {
  if (!account || !group.lastVisibleMessageId || Date.parse(group.expiresAt) <= Date.now()) return false;
  const value = positions(account);
  return value[group.id]?.messageId !== group.lastVisibleMessageId;
}
export function markGroupRead(account: string | null, group: string, messageId: string | undefined, expiresAt: string) {
  if (!account || !messageId || Date.parse(expiresAt) <= Date.now()) return;
  save(account, { ...positions(account), [group]: { messageId, expiresAt } });
}
export function forgetGroupRead(account: string | null, group: string) {
  if (!account) return;
  const value = positions(account); delete value[group]; save(account, value);
}

export function pruneGroupReads(account: string | null, visibleIds?: readonly string[]) {
  if (!account) return;
  const visible = visibleIds ? new Set(visibleIds) : null;
  save(account, Object.fromEntries(Object.entries(positions(account)).filter(([id]) => !visible || visible.has(id))));
}

export function clearFriendshipReadPositions(account: string | null) { if (account) save(account, {}); }
